/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTestDto } from './GetTestDto';
import {
    GetTestDtoFromJSON,
    GetTestDtoFromJSONTyped,
    GetTestDtoToJSON,
} from './GetTestDto';

/**
 * 
 * @export
 * @interface GetBatteryWithTestsDto
 */
export interface GetBatteryWithTestsDto {
    /**
     * 
     * @type {string}
     * @memberof GetBatteryWithTestsDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetBatteryWithTestsDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetBatteryWithTestsDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<GetTestDto>}
     * @memberof GetBatteryWithTestsDto
     */
    testsDto?: Array<GetTestDto> | null;
}

/**
 * Check if a given object implements the GetBatteryWithTestsDto interface.
 */
export function instanceOfGetBatteryWithTestsDto(value: object): value is GetBatteryWithTestsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetBatteryWithTestsDtoFromJSON(json: any): GetBatteryWithTestsDto {
    return GetBatteryWithTestsDtoFromJSONTyped(json, false);
}

export function GetBatteryWithTestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBatteryWithTestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'testsDto': json['testsDto'] == null ? undefined : ((json['testsDto'] as Array<any>).map(GetTestDtoFromJSON)),
    };
}

export function GetBatteryWithTestsDtoToJSON(value?: GetBatteryWithTestsDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'testsDto': value['testsDto'] == null ? undefined : ((value['testsDto'] as Array<any>).map(GetTestDtoToJSON)),
    };
}

